"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLocalizers = exports.setMessageLocalizer = exports.setNumberLocalizer = exports.setDateLocalizer = void 0;
var localizers_1 = require("./util/localizers");
exports.setDateLocalizer = localizers_1.setDate;
exports.setNumberLocalizer = localizers_1.setNumber;
exports.setMessageLocalizer = localizers_1.setMessage;
function setLocalizers(_a) {
  var date = _a.date,
    number = _a.number,
    message = _a.message;
  date && exports.setDateLocalizer(date);
  number && exports.setNumberLocalizer(number);
  message && exports.setMessageLocalizer(message);
}
exports.setLocalizers = setLocalizers;
exports.default = {
  setDateLocalizer: exports.setDateLocalizer,
  setNumberLocalizer: exports.setNumberLocalizer,
  setMessageLocalizer: exports.setMessageLocalizer,
  setLocalizers: setLocalizers
};